import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@core/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { EmbeddedReportService } from './services/embedded-report.service';
import { EmbeddedReportComponent } from './embedded-report/embedded-report.component';
import { ReportsComponent } from './reports.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule,
        NgbModule,
        FormsModule,
        RouterModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [EmbeddedReportService],
    declarations: [
        EmbeddedReportComponent,
        ReportsComponent        
    ]
})
export class EmbeddedReportModule { }